module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(967);
	module.exports = __webpack_require__(967);


/***/ },

/***/ 3:
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },

/***/ 967:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(968)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function() {

	(function ($) {
	    // Imports ================================================================
	    var math = Math,
	        kendo = window.kendo,
	        deepExtend = kendo.deepExtend,
	        inArray = $.inArray;

	    // Mixins =================================================================
	    var ObserversMixin = {
	        observers: function() {
	            this._observers = this._observers || [];
	            return this._observers;
	        },

	        addObserver: function(element) {
	            if (!this._observers)  {
	                this._observers = [element];
	            } else {
	                this._observers.push(element);
	            }
	            return this;
	        },

	        removeObserver: function(element) {
	            var observers = this.observers();
	            var index = inArray(element, observers);
	            if (index != -1) {
	                observers.splice(index, 1);
	            }
	            return this;
	        },

	        trigger: function(methodName, event) {
	            var observers = this._observers;
	            var observer;
	            var idx;

	            if (observers && !this._suspended) {
	                for (idx = 0; idx < observers.length; idx++) {
	                    observer = observers[idx];
	                    if (observer[methodName]) {
	                        observer[methodName](event);
	                    }
	                }
	            }
	            return this;
	        },

	        optionsChange: function(e) {
	            e = e || {};
	            e.element = this;
	            this.trigger("optionsChange", e);
	        },

	        geometryChange: function() {
	            this.trigger("geometryChange", {
	                element: this
	            });
	        },

	        suspend: function() {
	            this._suspended = (this._suspended || 0) + 1;
	            return this;
	        },

	        resume: function() {
	            this._suspended = math.max((this._suspended || 0) - 1, 0);
	            return this;
	        },

	        _observerField: function(field, value) {
	            if (this[field]) {
	                this[field].removeObserver(this);
	            }
	            this[field] = value;
	            value.addObserver(this);
	        }
	    };

	    // Exports ================================================================
	    deepExtend(kendo, {
	        mixins: {
	            ObserversMixin: ObserversMixin
	        }
	    });

	})(window.kendo.jQuery);

	return window.kendo;

	}, __webpack_require__(3));


/***/ },

/***/ 968:
/***/ function(module, exports) {

	module.exports = require("../kendo.core");

/***/ }

/******/ });